﻿(function () {

    'use strict';
    var serviceId = 'repository.progressdepotorder';
    angular
        .module('app.services')
        .factory(serviceId, progressdepotorder);

    progressdepotorder.$inject = ['common', 'repository.abstract', '$http'];

    function progressdepotorder(common, abstractRepository, $http) {
        var config = common.config;
        function Ctor(mgr) {
            this.manager = mgr;
            this.getFilters = getFilters;
            this.getCarrierByName = getCarrierByName;
            this.getProgressDepotOrderList = getProgressDepotOrderList;
            this.exportProgressDepotOrder = exportProgressDepotOrder;
        }

        abstractRepository.extend(Ctor);

        return Ctor;
             
        function getFilters()
        {
            var authData = common.localStorageService.get('authorizationData');
            var codeRole = authData ? authData.userRole : "";
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetProgressDepotOrderFilters?codeRole=' + codeRole);
        }

        function getCarrierByName(carrierName) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetCarrierByName?criteria=' + carrierName);
        }

        function getProgressDepotOrderList(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/GetDepotOrderList', model);
        }

        function exportProgressDepotOrder(model)
        {
            var result = common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/exportProgressDepotOrder', model);
            return result;
        }
        
        function getApplicationSettingValue(categoryName, settingName) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/getApplicationSettingValue?categoryName=' + categoryName + '&settingName='+ settingName);
        }

    }

})();
